import OracleOrb from "./OracleOrb.jsx";
import { G } from "../constants.js";
import { useIsMobile } from "../hooks/useIsMobile.js";

export default function BallPhase({ phase, onEnter, onSkip, isReturning, images, imageCount, orbSize, onShowOnboarding }) {
  const { isMobile } = useIsMobile();
  const mobileOrbSize = isMobile ? Math.min(orbSize || 320, 260) : orbSize || 320;

  return (
    <div style={{ minHeight:"100vh", background:"#070710", backgroundImage:"radial-gradient(ellipse 70% 70% at 50% 50%, rgba(255,255,255,.04) 0%, #070710 70%)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif", overflow:"hidden", padding:"20px", touchAction:"none", overscrollBehavior:"none", userSelect:"none" }}>
      <style>{G}</style>

      {onShowOnboarding && (
        <button onClick={onShowOnboarding} style={{ position:"absolute", top:"16px", left:"16px", width:"32px", height:"32px", borderRadius:"50%", border:"1px solid rgba(255,255,255,.12)", background:"rgba(255,255,255,.04)", color:"rgba(255,255,255,.35)", fontFamily:"'DM Mono'", fontSize:"13px", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center" }}>?</button>
      )}
      {isReturning && (
        <button onClick={onSkip} style={{ position:"absolute", top:"16px", right:"16px", padding:"7px 14px", borderRadius:"8px", border:"1px solid rgba(255,255,255,.1)", background:"rgba(255,255,255,.04)", color:"rgba(255,255,255,.4)", fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".1em", textTransform:"uppercase", cursor:"pointer" }}>
          {isMobile ? "Library" : "Skip to Library"}
        </button>
      )}

      <div style={{ textAlign:"center", marginBottom:isMobile?"28px":"44px", zIndex:1 }}>
        <p style={{ fontFamily:"'Bebas Neue'", fontSize:isMobile?"26px":"32px", letterSpacing:".25em", color:"#E8FF47", marginBottom:"8px" }}>ORACLE</p>
        <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".24em", color:"rgba(255,255,255,.18)", textTransform:"uppercase" }}>your visual library</p>
      </div>

      <div style={{ zIndex:1 }}>
        <OracleOrb phase={phase} onEnter={onEnter} images={images} size={mobileOrbSize} />
      </div>

      <div style={{ marginTop:isMobile?"28px":"32px", zIndex:1, textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", gap:"8px" }}>
        <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", color:"rgba(255,255,255,.22)", letterSpacing:".18em", textTransform:"uppercase" }}>
          {isMobile ? "Tap to enter" : "Click the orb to enter"}
        </p>
        {imageCount > 0 && (
          <p style={{ fontFamily:"'DM Mono'", fontSize:"11px", color:"rgba(255,255,255,.2)", letterSpacing:".08em" }}>
            <span style={{ color:"#E8FF47" }}>{imageCount}</span> {imageCount === 1 ? "image" : "images"} in your library
          </p>
        )}
        {(orbSize >= 360) && (
          <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(232,255,71,.2)", letterSpacing:".12em", textTransform:"uppercase" }}>
            Library growing  -  ready to burst
          </p>
        )}
      </div>
    </div>
  );
}
